// API Configuration for Slimmy App
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API_URL = BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
